module.exports = __webpack_public_path__ + "static/media/4.82c8c1c6.png";